import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://register.educatory.ac/api';
// const API_URL = 'https://register.educatory.ac/api';

export const registerTeacher = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/teachers/register`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getReferralStudents = async (referralCode) => {
  try {
    if (!referralCode) {
      throw new Error('Referral code is required');
    }
    const response = await axios.get(`${API_URL}/teachers/referrals?referralCode=${referralCode}`);
    return response.data;

  } catch (error) {
    throw error;
  }
};

export const registerScholarship = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/scholarships/register`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const validateScholarshipCode = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/scholarships/validate`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyScholarshipOTP = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/scholarships/verify-otp`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendAmbassadorOTP = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/ambassadors/send-otp`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const registerAmbassador = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/ambassadors/register`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendScholarshipOTP = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/scholarships/send-otp`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyAdmin = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/admin/verify-admin`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const sendCredentialsEmail = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/admin/send-credentials`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};